define('app/views/yadisa_checkout_wrap_option',['app/setup'], function(takhfifan) {

  takhfifan.YadisaCheckoutWrapOption = Backbone.View.extend({

    events: {
      'change input[name="yadisadeliveryOption"]': 'toggleGiftWrap'
    },

    initialize: function (options) {
      var _this = this;
      this.$el.find('#yadisaCOGiftWrap').prop('checked', false);
      if($('.tkh-cart-item.yadisa-gift-wrap').length){
        _this.removeUrl = $('.tkh-cart-item.yadisa-gift-wrap .tkh-cart-item-remove').attr('href');
        this.enableGiftWrap();
      }
      this.enableItems();
    },

    toggleGiftWrap: function(e){
      this.disableItems();
      switch($(e.target).val()){
        case 'email':
          if(this.removeUrl){
            window.location = this.removeUrl;
          }
          return;
        case 'wrap':
          $.get("/checkout/cart/addGiftWrappingToCart",function(data,textStatus,jqXHR){
            if(jqXHR.status === 200){
              location.reload();
            }
          });
          return;
      }
    },

    disableItems : function () {
      this.$el.addClass('disable');
      this.$el.find('input[name="yadisadeliveryOption"]').attr('disabled', 'true');
    },

    enableItems : function () {
      this.$el.removeClass('disable');
      this.$el.find('input[name="yadisadeliveryOption"]').removeAttr('disabled');
    },

    enableGiftWrap: function(){
      this.$el.find('input[value="wrap"]').prop('checked', true);
      this.$el.addClass('gift-wrap');
      takhfifan.eventHub.trigger('yadisa:giftWrapSelected');
    }

  })
});
